"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/slicedToArray"));

var _oss = require("../../../utils/oss");

var _util = require("../../../utils/util");

//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'FormOssImage',
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    displayPath: function displayPath() {
      return (0, _oss.ossUrl)(this.valueProxy, 'normal_progressive');
    }
  },
  methods: {
    // 从 input 的 event 中获取 file
    getFirstFile: function getFirstFile(_ref) {
      var srcElement = _ref.srcElement,
          target = _ref.target;

      var _ref2 = target || srcElement,
          files = _ref2.files; // 获取 files


      if (!files) {
        return undefined;
      }

      var _files = (0, _slicedToArray2.default)(files, 1),
          file = _files[0]; // 获取选中的第一个文件


      if (!file) {
        return undefined;
      }

      return file;
    },
    // 过滤文件类型
    verification: function verification(_ref3) {
      var type = _ref3.type;
      return ['image/jpeg', 'image/png', 'image/gif'].includes(type);
    },
    upload: function () {
      var _upload2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var file, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.prev = 1;
                file = this.getFirstFile(event);

                if (file) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (this.verification(file)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("\u4E0D\u652F\u6301\u7684\u6587\u4EF6\u7C7B\u578B\uFF1A ".concat(file.type));

              case 7:
                _context.next = 9;
                return (0, _oss.upload)(file, (0, _oss.getPath)("book/cover/".concat((0, _util.randomString)()).concat((0, _util.getFileExt)(file))));

              case 9:
                this.valueProxy = _context.sent;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 16:
                _context.prev = 16;
                this.loading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 12, 16, 19]]);
      }));

      function upload(_x) {
        return _upload2.apply(this, arguments);
      }

      return upload;
    }()
  }
};
exports.default = _default;